import { Container, Cell, PlaceHolder, CellContainer } from "./styles";

const WorkersPopper = ({
  isOpen,
  onClose,
  Workers = [
    { username: "Popper Party", rank: "Administrador" },
    { username: "Popper Party", rank: "Gerente" },
    { username: "Popper Party", rank: "Colaborador" },
    { username: "Popper Party", rank: "Failed" },
    { username: "Popper Party", rank: "Failed" },
    { username: "Popper Party", rank: "Failed" },
    { username: "Popper Party", rank: "Failed" },
    { username: "SirPopper Party", rank: "Failed" },
  ],
}) => {
  return (
    <Container open={isOpen}>
      <CellContainer>
        {Workers.length > 0
          ? Workers.map((item, index) => (
              <Cell key={index}>
                <PlaceHolder src={item.avatarURL} />
                <span>{item?.username.split(" ")[0]}</span>
              </Cell>
            ))
          : null}
      </CellContainer>
    </Container>
  );
};

export default WorkersPopper;
